
// @ts-nocheck
import locale__opt_build_repo_locales_it_json from "../locales/it.json";
import locale__opt_build_repo_locales_en_json from "../locales/en.json";
import locale__opt_build_repo_locales_es_json from "../locales/es.json";


export const localeCodes =  [
  "it",
  "en",
  "es"
]

export const localeLoaders = {
  "it": [{ key: "../locales/it.json", load: () => Promise.resolve(locale__opt_build_repo_locales_it_json), cache: true }],
  "en": [{ key: "../locales/en.json", load: () => Promise.resolve(locale__opt_build_repo_locales_en_json), cache: true }],
  "es": [{ key: "../locales/es.json", load: () => Promise.resolve(locale__opt_build_repo_locales_es_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "it",
      "name": "Italiano",
      "files": [
        "/opt/build/repo/locales/it.json"
      ]
    },
    {
      "code": "en",
      "name": "English",
      "files": [
        "/opt/build/repo/locales/en.json"
      ]
    },
    {
      "code": "es",
      "name": "Español",
      "files": [
        "/opt/build/repo/locales/es.json"
      ]
    }
  ],
  "defaultLocale": "it",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "it",
    "name": "Italiano",
    "files": [
      {
        "path": "/opt/build/repo/locales/it.json"
      }
    ]
  },
  {
    "code": "en",
    "name": "English",
    "files": [
      {
        "path": "/opt/build/repo/locales/en.json"
      }
    ]
  },
  {
    "code": "es",
    "name": "Español",
    "files": [
      {
        "path": "/opt/build/repo/locales/es.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
